'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var argsToForm = function argsToForm(args) {
  var data = new FormData();
  Object.keys(args).forEach(function (key) {
    if (args.hasOwnProperty(key)) {
      data.append(key, args[key]);
    }
  });
  return data;
};

var http = function http(url, method, args, params) {
  var data = args ? argsToForm(args) : undefined;
  return (0, _axios2.default)({
    method: method,
    url: url,
    data: data,
    params: params,
    withCredentials: true,
    maxRedirects: 0,
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(function (r) {
    return r.data ? r.data : r;
  });
};

exports.default = http;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-autosuggest/dist/utils/http.js
// module id = 390
// module chunks = 168707334958949